import React from 'react';
import { Col, Row } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import cn from 'classnames';
import './styles.scss';

const GEO_TYPE_NAME = {
  States: 'States',
  Cities: 'Cities',
  ZipCodes: 'Zip Codes',
  CongressionalDistricts: 'Congressional Districts',
  StateLegislativeDistricts: 'State Legislative Districts',
};

const GeoList = ({
  geographyIds = [],
  geographyZipCodeIds = [],
  geographiesObj = {},
  onRemoveGeography,
  onRemoveZipCode,
  className = '',
  showTypeLabels = true,
  clearAll,
  geoKeyName = GEO_TYPE_NAME,
}) => {
  const listGeographyIds = [...geographyIds, ...geographyZipCodeIds];

  const handleRemoveGeography = (id) => {
    if (onRemoveGeography) {
      onRemoveGeography(id);
    }
  };

  const handleRemoveZipCode = (idx) => {
    if (onRemoveZipCode) {
      onRemoveZipCode(idx);
    }
  };

  return (
    <div className={cn('geo-list-wrapper w-100p ', className)}>
      {listGeographyIds.length > 0 && (
        <>
          {/* Group items by type and show separate labels */}
          {(() => {
            const groupedItems = {};

            // Group geography items by type
            geographyIds.forEach((id) => {
              const { type } = geographiesObj[id] || {};
              if (type && !groupedItems[type]) {
                groupedItems[type] = [];
              }
              if (type) {
                groupedItems[type].push(id);
              }
            });

            // Group zip code items
            if (geographyZipCodeIds.length > 0) {
              groupedItems.ZipCodes = geographyZipCodeIds;
            }

            return Object.entries(groupedItems).map(([type, items]) => (
              <div key={type} className="geography-type-section">
                {showTypeLabels && geoKeyName[type] && (
                  <div className="geography-type-label">
                    {geoKeyName[type]} (
                    {items.length.toString().padStart(2, '0')})
                  </div>
                )}
                <Row gutter={[10, 10]}>
                  {type === 'ZipCodes'
                    ? // Render zip codes
                      items.map((id, idx) => (
                        <Col key={`zip-${id}`}>
                          <div className="geography-item action">
                            <span className="name">
                              {[geoKeyName.ZipCodes, id].join(' - ')}
                            </span>
                            <CloseOutlined
                              onClick={() => handleRemoveZipCode(idx)}
                            />
                          </div>
                        </Col>
                      ))
                    : // Render other geography types
                      items.map((id) => {
                        const { type: itemType, name } =
                          geographiesObj[id] || {};
                        return (
                          <Col key={id}>
                            <div className="geography-item action">
                              {geoKeyName[itemType] ? (
                                <span className="name">
                                  {[geoKeyName[itemType], name].join(' - ')}
                                </span>
                              ) : (
                                <span className="name">{name}</span>
                              )}
                              <CloseOutlined
                                onClick={() => {
                                  if (clearAll) {
                                    clearAll();
                                  }
                                  handleRemoveGeography(id);
                                }}
                              />
                            </div>
                          </Col>
                        );
                      })}
                </Row>
              </div>
            ));
          })()}
        </>
      )}
    </div>
  );
};

export default GeoList;
